import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import {dd,store,app} from 'systems/imports'
import routes from 'systems/routes'

import AppTranslation from 'processor/AppTranslation'

const router = new VueRouter(routes) // ルーターインスタンスの作成

//ページ読み込み時に言語設定を更新
router.beforeEach((to, from, next) => {


  //ログイン後ページは認証が無い場合はトップへ
  if (to.matched.some(route => route.meta.isLoggedInPage)) {
    if(!store.get("token")){
      return next({ name: 'demo-login' })
    }
  }
  //言語設定を更新する
  AppTranslation.refresh()
  //ヘッダー、フッターレイアウトを調整
  app.make("_").debounce(app.make("adjustLayout"),500)()
  next()
})

export default router;



// WEBPACK FOOTER //
// ./src/systems/router.js